module.exports = __webpack_public_path__ + "img/3.d4f19c49.jpg";